import { Bar,Doughnut } from 'react-chartjs-2';
import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend,ArcElement);
const ChartAll = ({data,options,chartType,doughnutData,doughnutOptions,plugins}) => {
    return(
      <>
      {chartType=='barChart' ?
        <Bar data={data} options={options} />
        :
        <Doughnut data={doughnutData} options={doughnutOptions} plugins={plugins} />
      }
      </>
    ) 
  };
  export default ChartAll;